var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallStatusMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 12.5,
    fill: "#FFF",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    fillRule: "nonzero",
    d: "M20.25 14.663a.377.377 0 00-.385-.369.377.377 0 00-.384.369c0 2.234-1.898 4.052-4.231 4.052-.947 0-1.822-.3-2.528-.804l.962-1.152c.441.304.982.483 1.566.483 1.485 0 2.692-1.157 2.692-2.58V11.66l2.224-2.662a.358.358 0 00-.06-.518.396.396 0 00-.541.058l-1.623 1.943v-.24c0-1.421-1.207-2.578-2.692-2.578s-2.692 1.157-2.692 2.579v4.42c0 .597.212 1.147.569 1.585l-.977 1.17a3.947 3.947 0 01-1.13-2.754.377.377 0 00-.385-.369.377.377 0 00-.385.369 4.67 4.67 0 001.415 3.334l-1.33 1.594a.358.358 0 00.06.517.394.394 0 00.54-.057l1.307-1.565a5.1 5.1 0 002.623.952v1.488h-1.153a.377.377 0 00-.385.368c0 .204.172.369.385.369h3.076a.377.377 0 00.385-.369.377.377 0 00-.385-.368h-1.153v-1.488c2.578-.189 4.615-2.258 4.615-4.775zm-3.077 0c0 1.015-.863 1.842-1.923 1.842a1.98 1.98 0 01-1.085-.322l3.008-3.602v2.082zm-3.846 0v-4.421c0-1.016.863-1.842 1.923-1.842s1.923.826 1.923 1.842v1.16l-3.546 4.246c-.19-.285-.3-.623-.3-.985z"
  }))));
}

export default SvgCallStatusMute;